import { render, staticRenderFns } from "./WebNtaxCode.vue?vue&type=template&id=4b015672&"
import script from "./WebNtaxCode.vue?vue&type=script&lang=js&"
export * from "./WebNtaxCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports